/* eslint-disable multiline-ternary */
import { Grid, Paper, TextField, TextFieldProps } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import MoneyOffIcon from '@material-ui/icons/MoneyOff'
import React, { useState } from 'react'
import NumberFormat from 'react-number-format'
import { useBudgetStyles } from './styles'
import { Procedure } from './types'

interface BudgetProps {
  procedure: Procedure
  handleChange: (value: number) => void
  descount: number
}

const AmountCustomInput = (props: TextFieldProps) => (
  <TextField label="Desconto" {...props} />
)
const BudgetDescount: React.FC<BudgetProps> = ({
  procedure,
  handleChange,
  descount
}) => {
  const [edit, setEditing] = useState<boolean>(false)
  const classes = useBudgetStyles()

  return (
    <Paper elevation={0} className={classes.root}>
      <Grid container justify="space-around" alignItems="center">
        <Grid xs={4} className={classes.name}>
          <MoneyOffIcon
            className={classes.addIcon}
            style={{ marginRight: 10 }}
          />
          {procedure.name}
        </Grid>
        {edit ? (
          <Grid xs={4}>
            <NumberFormat
              onBlur={() => setEditing(false)}
              style={{ width: '100%' }}
              prefix="R$ "
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              value={descount}
              onValueChange={values => handleChange(values.floatValue || 0)}
              allowNegative={false}
              allowedDecimalSeparators={['.', ',']}
              customInput={AmountCustomInput}
            />
          </Grid>
        ) : (
          <Grid
            xs={4}
            className={classes.value}
            style={{ textAlign: 'center' }}
            onClick={() => setEditing(!edit)}
          >
            <NumberFormat
              prefix="R$ "
              isNumericString
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              displayType="text"
              value={procedure.totalPrice?.format}
            />
          </Grid>
        )}
        <Grid xs={4} style={{ textAlign: 'right' }}>
          <EditIcon
            className={classes.icon}
            onClick={() => setEditing(!edit)}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default BudgetDescount
